import React, { useState } from "react";
import { Box, Paper, TextField, Button, Typography, Alert } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useTheme } from "../contexts/ThemeContext";

export default function Login() {
  const { login } = useAuth();
  const { T } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      const redirectTo = location.state?.from?.pathname || "/dashboard";
      navigate(redirectTo, { replace: true });
    } catch (err) {
      // AuthContext.login throws plain Errors carrying an already
      // user-facing message for ATS-access failures (company not enabled,
      // no role assigned, etc). Anything else is a credentials/network
      // failure straight from the API, which still has .response.
      setError(
        err.message && !err.response
          ? err.message
          : err.response?.data?.detail || "Invalid email or password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
        bgcolor: T.bg,
      }}
    >
      <Paper sx={{ width: 400, p: 4, backgroundColor: T.card, border: `1px solid ${T.border}` }}>
        <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5, color: T.text }}>Hirality ATS</Typography>
        <Typography variant="body2" sx={{ mb: 3, color: T.muted }}>
          Sign in to your workspace
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Email" type="email" value={email} required fullWidth
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Password" type="password" value={password} required fullWidth
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit" variant="contained" size="large" disabled={loading} sx={{ mt: 1 }}>
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}